import React, { useEffect, useState } from "react";
import styles from "./formCategory.module.css";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import TextField from "component/textField/TextField";
import LabeledSelect from "component/select/labeledSelect/LabeledSelect";
import {
  useGetCities,
  useGetLGA,
  useGetStates,
} from "api/queries/dashboard/misc";
import AppDatePicker from "component/inputs/datePicker/DatePicker";
import { removeUnderscore } from "utils/helpers";

const residentialStatus = [
  "LIVING_WITH_PARENT",
  "OWNED",
  "RENT",
  "EMPLOYER_PROVIDED",
];


function ApplicationAddress({
  watch,
  trigger,
  errors,
  setValue,
  formData,
  register,
}) {
 
  const { states, loading } = useGetStates();
  const { LGA, setStateID } = useGetLGA();  
  const { cities, setStateID: setStateIdForCities } = useGetCities();

  const state = watch("state", "");
  const residenceSince = watch("residenceSince", "");

  useEffect(() => {
    const code = states?.find((_state) => {
      return _state.name === state;
    })?.state_code;
    setStateID(code);
    setStateIdForCities(code);
  }, [state]);


  useEffect(() => {
    if (formData.state) {
      setValue("state", formData.state);
      setStateID(
        states?.find((_state) => {
          return _state.name === formData.state;
        })?.state_code
      );
    }
  }, [states]);



  useEffect(() => {
    setValue("lga", formData?.lga);
  }, [LGA]);

  return (
    <div className={styles.category_tab}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={4}>
          <div className={styles.category}>
            <Typography variant="h6">Applicant’s Address</Typography>
            <Typography>
              Please provide your current residential detailsss
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} sm={8}>
          <div className={styles.category_form}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <div className={styles.field}>
                  <TextField
                    required={true}
                    name="address"
                    register={register}
                    errors={errors}
                    label="Address"
                    type="text"
                    placeholder="Address"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <LabeledSelect
                    required={true}
                    name="state"
                    data={states?.map((state) => {
                      return {
                        label: state.name,
                        value: state.name,
                      };
                    })}
                    register={register}
                    errors={errors}
                    label="State"
                    placeholder="Select State"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <LabeledSelect
                    required={true}
                    name="lga"
                    data={LGA?.map((state) => {
                      return {
                        label: state,
                        value: state,
                      };
                    })}
                    register={register}
                    errors={errors}
                    label="LGA"
                    placeholder="Select LGA"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <div className={styles.field}>
                    <LabeledSelect
                      required={true}
                      name="city"
                      register={register}
                      errors={errors}
                      label="City"
                      data={cities}
                      placeholder="Select City"
                    />
                  </div>
                
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <AppDatePicker
                    required={true}
                    errors={errors}
                    name="residenceSince"
                    label="Residence since?"
                    setValue={setValue}
                    value={residenceSince}
                    trigger={trigger}
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <LabeledSelect
                    required={true}
                    name="residentialStatus"
                    data={residentialStatus.map((item) => {
                      return {
                        label: removeUnderscore(item.toLocaleLowerCase()),
                        value: item,
                      };
                    })}
                    register={register}
                    errors={errors}
                    label="Residential Status"
                    placeholder="Select Status"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default ApplicationAddress;